module.exports = __webpack_public_path__ + "static/media/Logo500.67eecd59.png";